import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import EmptyState from '@lib/components/EmptyState/EmptyState';
import { IconName } from '@lib/components/Modal/enums';

interface Props {
  onUpgrade: () => void;
  outlined?: boolean;
  rootClassName?: string;
  text: React.ReactNode;
  title: React.ReactNode;
}

function FeatureLockState({
  onUpgrade,
  outlined = true,
  rootClassName,
  text,
  title,
}: Props) {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon={IconName.Lock}
      title={title}
      text={text}
      outlined={outlined}
      rootClassName={rootClassName}
      actions={[
        <Button
          key="upgrade"
          buttonText={t('upgrade-plan')}
          buttonType={ButtonTypes.primaryFilled}
          onClick={onUpgrade}
        />,
      ]}
    />
  );
}

export default FeatureLockState;
